import styled, { css } from 'styled-components';

const Container = styled.div(
  ({ theme }) => css`
    position: relative;
    box-sizing: border-box;
    box-shadow: 0 32px 40px -10px ${theme.colors.grape_50};
    background-color: ${theme.colors.white};
    border-radius: 6px;
    margin: ${theme.spacing(12)};
    text-align: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 540px;
    max-height: 85vh;
  `,
);

export default Container;
